module.exports = __webpack_public_path__ + "static/chem-lab-glassware-baec803d5074b347b7cc9ee6d274daa7.jpg";